import { extend, configure } from 'vee-validate'
import i18n from './i18n.js'
import * as rules from 'vee-validate/dist/rules'
import th from 'vee-validate/dist/locale/th'

configure({
  defaultMessage: (field, values) => {
    // override the field name.
    values._field_ = i18n.t(`${field}`)
    return i18n.t(`validation.${values._rule_}`, values)
  }
})
// loop over all rules
for (let rule in rules) {
  extend(rule, {
    ...rules[rule], // add the rule
    message: th.messages[rule] // add its message
  })
}

extend('required', rules.required)

extend('isUrl', {
  validate: (value) => {
    return /^(ftp|https|line):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!]))?/.test(
      value
    )
  },
  message: 'ขึ้นต้นด้วย https:// เท่านั้น'
})
